import { API_ROOT } from '../../config/config'
import { doGet, doDownload, doPostFiles, doDelete } from './utils'

// const API_ROOT = 'http://localhost:9014/api'

const API_ROOT_VER = `${API_ROOT}/v1/accounting`

export const getSubProjectExpenseRecord = (projectCode, periodId, id) => {
  // /api/v1/accounting/subproject/expense/{projectCode}/{periodId}
  const url = `${API_ROOT_VER}/subproject/expense/${projectCode}/${periodId}?id=${id || ''}`
  return doGet(url)
}

export const saveSubProjectExpenseRecord = (request) => {
  // /api/v1/accounting/subproject/expense/save
  const url = `${API_ROOT_VER}/subproject/expense/save`
  return doPostFiles(url, request)
}

export const deleteSubProjectExpenseRecord = (id) => {
  // /api/v1/accounting/subproject/expense/{id}
  const url = `${API_ROOT_VER}/subproject/expense/${id}`
  return doDelete(url)
}

export const downloadSubProjectExpenseRecordAttacthment = (fileId) => {
  // /api/v1/accounting/subproject/expense/attachments/download/{fileId}
  const url = `${API_ROOT_VER}/subproject/expense/attachments/download/${fileId}`
  return doDownload(url)
}

export const downloadSubProjectExpenseRecordVoucherFile = (accountingExpensesId) => {
  const url = `${API_ROOT}/files/${accountingExpensesId}/payment/voucher/form`
  return doDownload(url)
}